@for (file of names; let fileIndex = $index; track fileIndex) {
    <p>
        <button mat-button color="primary" class="p-0 mt-0 border-0 rounded-0" (click)="downloadFile(file)">
            {{ file }}
        </button>
    </p>
}
